const webStorage = {

    prefix: 'default',

    // namespace stored values
    // default store name is "default"
    store(ns = 'default') {
        this.prefix = ns
        return this
    },

    // get the value or return a default (def) value
    // if the value exists but is expired, null is returned
    get(key, def = null) {
        let prefixed = this.getPrefix(key)
        console.log(prefixed);
        let data = JSON.parse(localStorage.getItem(prefixed) ?? null);
        if(!data) return null
        if(data.expiry >= new Date().getTime()) {
            return data.value
        }

        localStorage.removeItem(prefixed)
        return def
    },

    // set a value for a key. If seconds are specified, the value
    // will ve available until that date.
    put(key, value, seconds = 0){
        let prefixed = this.getPrefix(key)

        return localStorage.setItem(prefixed, JSON.stringify({
            value: value,
            expiry: this.expiration(seconds)
        }))
    },

    // check if the key exists. If the key exists but
    // is expired, null will be returned
    has(key) {
        let prefixed = this.getPrefix(key)

        let data = JSON.parse(localStorage.getItem(prefixed) ?? null)
        if(!data) return false

        if(data.expiry >= new Date().getTime()) {
            return true
        }

        localStorage.removeItem(prefixed)
        return false
    },

    // return the value for the specific key and removes it from the store
    // if the value is expired will be removed and null will be returned
    pull(key) {
        let prefixed = this.getPrefix(key)

        let data = JSON.parse(localStorage.getItem(prefixed) ?? null)
        if(!data) return null

        let value = (data.expiry >= new Date().getTime()) ? data.value : null

        localStorage.removeItem(prefixed)
        return value
    },

    // calculate the expiration timestamp
    expiration(seconds = 0) {
        if(seconds !== 0) {
            let time = new Date()
            time.setSeconds(time.getSeconds() + seconds)
            return time.getTime()
        }

        return 9999999999999
    },

    // get the store prefix
    getPrefix(key) {
        let prefixed = `goufone.${this.prefix}.${key}`
        this.prefix = 'default'
        return prefixed
    }
}

window.webStorage = webStorage

